export default __webpack_public_path__ + "static/media/logo-Vedix.25044bb0.svg";